/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ItauDadosQRCode {
  jornada?: ItauDadosQRCode.JornadaEnum;
  pixCopiaECola?: string;
}
export namespace ItauDadosQRCode {
  export type JornadaEnum =
    | 'JORNADA_1'
    | 'JORNADA_2'
    | 'JORNADA_3'
    | 'JORNADA_4';
  export const JornadaEnum = {
    _1: 'JORNADA_1' as JornadaEnum,
    _2: 'JORNADA_2' as JornadaEnum,
    _3: 'JORNADA_3' as JornadaEnum,
    _4: 'JORNADA_4' as JornadaEnum
  };
}
